/* eslint-disable import/first */
import React from 'react';
import { useNavigate } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage, useIntl } from 'react-intl';
import noItem from './images/not-found.svg';
import css from './index.module.scss';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import MyFavorites from '../MyFav';

export default function NoProduct({ favtCategory, setOpenSearch }) {
  const navigate = useNavigate();
  const { selectFirstCategory } = Slices.categorySlice;
  const intl = useIntl();
  const firstCategory = useSelector(selectFirstCategory);
  const path = generateCategoryRoute({ category: firstCategory, locale: intl.locale });
  const exploreMenu = (e) => {
    e.preventDefault();
    setOpenSearch(false);
    navigate(path);
  };

  return (
    <div className={css.noItem}>
      {favtCategory ? (
        <>
          <MyFavorites />
        </>
      ) : (
        <Grid container justify="center" alignItems="center" direction="column" spacing={2}>
          <Grid item>
            <img src={noItem} alt="No Item Found" />
          </Grid>
          <Grid item>
            <h2>
              <FormattedMessage id="noproduct_noitemtext" defaultMessage="OOPS!" />
            </h2>
          </Grid>
          <Grid item>
            <p>
              <FormattedMessage
                id="noproduct_found"
                defaultMessage="No result found for your search!"
              />
            </p>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" size="medium" onClick={exploreMenu}>
              <FormattedMessage id="explore_KFC_menu" defaultMessage="Explore KFC Menu" />
            </Button>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
